export const titleMotion = {
    initial: {
        opacity: 0
    },
    animate: {
       opacity: 1,
       transition: {
           delay: .5,
       }
    },
    exit: {
        opacity: 0,
        transition: {
            duration: .1
        }
    }
}

export const productsMotion = {
    initial: {
        opacity: 0,
        y: 20,
    },
    animate: {
       opacity: 1,
       y: 0,
       transition: {
           delay: .7,
        //    staggerChildren: .3,
           transition: {
            ease: [0.99, 0.15, 0, 0.86],
        }
       }
    },
    exit: {
        opacity: 0,
        x: -30,
        transition: {
            duration: .1,
            transition: {
                ease: [0.99, 0.15, 0, 0.86],
            }
        }
    }
}